import { render, staticRenderFns } from "./TeamIndividualsForm.vue?vue&type=template&id=5e2b7b8f"
import script from "./TeamIndividualsForm.vue?vue&type=script&lang=ts"
export * from "./TeamIndividualsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports